import {l} from "types/typescriptdefinisjoner_lederplan";
import {ModelloppdateringTjeneste} from "web/tjenester/ModelloppdateringTjeneste";
import {BeslutningRessurs} from "felles/tjenester/ressurser/BeslutningRessurs";
import {UuidGenerator} from "felles/tjenester/UuidGenerator";
import {regNavn} from "../../../felles/tjenester/tredjepartsTjenestenavn";
import {RedigerBeslutningDialog} from "./modale/redigerBeslutningDialog/redigerBeslutningDialog";
import {gettextCatalog} from "angular-gettext";
import _ from "lodash";


export class BeslutningTjeneste {

    static regNavn = "wm.møte.BeslutningTjeneste";

    static forInjisering() {
        return [
            UuidGenerator.regNavn,
            BeslutningRessurs.regNavn,
            ModelloppdateringTjeneste.regNavn,
            RedigerBeslutningDialog.regNavn,
            regNavn.gettext.gettextCatalog,
            BeslutningTjeneste
        ]
    }

    constructor(private uuidGenerator: UuidGenerator,
                private beslutningRes: BeslutningRessurs,
                private modelloppdatering: ModelloppdateringTjeneste,
                private beslutningDialog: RedigerBeslutningDialog,
                private gettextCatalog: gettextCatalog) {
    }

    initNyBeslutningSkjemaModell(sakId:string) {
        const modell = new Beslutningsskjemamodell(null);
        modell.spesifikasjon.id = this.uuidGenerator.generer();
        modell.spesifikasjon.sakId = sakId;
        return modell;
    }

    initRedigerBeslutningSkjemaModell(beslutning: l.BeslutningModell) {
        return new Beslutningsskjemamodell(beslutning);
    }

    visNyBeslutningDialogMedAvstemningSomMal(avstemning:l.AvstemningMedResultatModell, avstemningsstatus: l.AvstemningsstatusModell) {
        let beskrivelse = this.beslutningBeskrivelseMedAvstemningSomMal(avstemning, avstemningsstatus);
        this.beslutningDialog.visNyFerdigutfyltBeslutningDialog(avstemning.sakId, avstemning.eiendeGruppeId, avstemning.tittel, beskrivelse);
    }

    //offentlig for å være testbar
    beslutningBeskrivelseMedAvstemningSomMal(avstemning: l.AvstemningMedResultatModell, avstemningsstatus: l.AvstemningsstatusModell):string {
        const overskrift = this.gettextCatalog.getString('Avstemningsresultat');
        const vinnere = _(avstemning.avstemningsalternativer).filter((alternativ: l.AvstemningsalternativMedResultatModell) => alternativ.erVinner);
        const resultat = _(avstemning.avstemningsalternativer).map((alternativ: l.AvstemningsalternativMedResultatModell) => {
            const tekst = this.gettextCatalog.getPlural(alternativ.antallStemmer, '{{tittel}} ({{antall}} stemme)', '{{tittel}} ({{antall}} stemmer)', {tittel: alternativ.tittel, antall: alternativ.antallStemmer});
            return alternativ.erVinner ? `<li><b>${tekst}</b></li>` : `<li>${tekst}</li>`;
        }).join('')
        let vinnertekst = '';
        if (vinnere.size() === 1) {
            vinnertekst = this.gettextCatalog.getString('Alternativ "{{tittel}}" vant med {{antall}} stemmer.', {tittel: vinnere.first().tittel, antall: vinnere.first().antallStemmer})
        }
        if (vinnere.size() > 1) {
            const titler = vinnere.reduce((titler: string, alternativ: l.AvstemningsalternativMedResultatModell, indeks: number) => {
                const skilletegn = indeks == 0 ? '' : indeks == vinnere.size() - 1 ? (' ' + this.gettextCatalog.getString('og') + ' ') : ', ';
                return `${titler}${skilletegn}"${alternativ.tittel}"`;
            }, '');
            vinnertekst = this.gettextCatalog.getString('Alternativene {{titler}} vant med {{antall}} stemmer.', {titler: titler, antall: vinnere.first().antallStemmer})
        }
        let beskrivelse = !_.isNil(avstemning.beskrivelse) ? `${avstemning.beskrivelse}<br><br>` : '';
        beskrivelse += `<i>${overskrift}:</i><ul>${resultat}</ul>`;
        if (!_.isEmpty(vinnertekst)) beskrivelse += `<br>${vinnertekst}`;
        beskrivelse += '<br>' + this.gettextCatalog.getString('{{antallStemt}} av {{antallStemmeberettigede}} stemmeberettigede har avgitt stemme.', {antallStemt: avstemningsstatus.antallStemmerAvgittPerAvstemning[avstemning.id], antallStemmeberettigede: avstemningsstatus.antallStemmeberettigedeDeltakere});
        return beskrivelse;
    }

    opprettBeslutning(spesifikasjon: Beslutningsskjemamodell) {
        return this.beslutningRes.opprett(spesifikasjon.somSpesifikasjon()).$promise
            .then(ny => {
                this.modelloppdatering.broadcastLokalNyBeslutning(ny);
                return ny;
            });
    }

    oppdaterBeslutning(spesifikasjon: Beslutningsskjemamodell) {
        return this.beslutningRes.oppdater(spesifikasjon.somSpesifikasjon()).$promise
            .then(oppdatert => {
                this.modelloppdatering.broadcastLokalOppdatertBeslutning(oppdatert);
                return oppdatert;
            })
    }

    slett(beslutning: l.BeslutningModell) {
        return this.beslutningRes.slett(beslutning.id).$promise
            .then(() => this.modelloppdatering.broadcastLokalSlettetBeslutning(beslutning.id));
    }
}

export class Beslutningsskjemamodell {

    constructor(mal: l.BeslutningModell) {
        this.spesifikasjon = {
            id: mal ? mal.id : null,
            tittel: mal ? (mal.erForslag ? mal.tittelForslag : mal.tittel) : null,
            beskrivelse: mal ? (mal.erForslag ? mal.beskrivelseForslag : mal.beskrivelse) : null,
            erForslag: mal ? mal.erForslag : true,
            sakId: mal ? mal.sakId : null
        };
    }

    spesifikasjon: l.OppdaterBeslutningOgOppgaverSpesifikasjon;

    somSpesifikasjon() {
        return this.spesifikasjon;
    }
}

